import { Theme } from '@theme'
import { StyleSheet } from 'react-native'

export const textStyles = (theme: Theme) =>
  StyleSheet.create({
    titleBigBold: {
      fontSize: theme.fontSize.huge,
      fontWeight: 'bold',
    },
    headline: {
      fontSize: theme.fontSize.extraLarge,
      fontWeight: 'bold',
    },
    titleBold: {
      fontSize: theme.fontSize.large,
      fontWeight: 'bold',
    },
    title: {
      fontSize: theme.fontSize.large,
    },
    subtitleBold: {
      fontSize: theme.fontSize.mediumPlus,
      fontWeight: 'bold',
    },
    bodyBold: {
      fontSize: theme.fontSize.medium,
      fontWeight: 'bold',
    },
    body: {
      fontSize: theme.fontSize.medium,
    },
    bodySmall: {
      fontSize: theme.fontSize.small,
    },
    bodySmallBold: {
      fontSize: theme.fontSize.small,
      fontWeight: 'bold',
    },
    bodyExtraSmall: {
      fontSize: theme.fontSize.extraSmall,
    },
    bodyExtraSmallBold: {
      fontSize: theme.fontSize.extraSmall,
      fontWeight: 'bold',
    },
    microText: {
      fontSize: theme.fontSize.tiny,
    },
  })

export type StyleKeys = keyof ReturnType<typeof textStyles>
